export var toAnalyticsHosting = function toAnalyticsHosting(hosting) {
  return {
    CLOUD: 'UNEXPECTED',
    SERVER: 'server',
    DATA_CENTER: 'datacenter'
  }[hosting];
};